export { AdvertisementSlot } from './AdvertisementSlot';

export type { AdvertisementSlotProps } from './AdvertisementSlot';